import { createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import Main from './-Main';
import { NotFound } from 'r/ui';

export const Route = createRootRoute({
  component: () => (
    <>
      <Main />
      <TanStackRouterDevtools />
    </>
  ),
  notFoundComponent: () => <NotFound />,
});
